/**
 * Created by zura on 08.06.20.
 */
import Vue from 'vue';
import moment from 'moment';

Vue.filter('toDate', function (value, format) {
  if (!value) return '';
  return moment(value).format(format || 'YYYY-MM-DD');
});

Vue.filter('toDatetime', function (value, format) {
  if (!value) return '';
  return moment(value).format(format || 'YYYY-MM-DD HH:mm:ss');
});